export default function degreeToRadian(degree: number) {
  return degree * (Math.PI / 180)
}